{
  "panel": {
    "title": "নোট",
    "newNote_title": "নতুন নোট",
    "search_placeholder": "নোট অনুসন্ধান করুন…",
    "search_aria": "নোট অনুসন্ধান করুন",
    "clearSearch_aria": "অনুসন্ধান মুছুন",
    "editorPlaceholder": "আপনার মনে কী আছে…",
    "titleInput_placeholder": "শিরোনাম নেই",
    "untitled": "শিরোনামহীন",
    "emptyNote": "খালি নোট",
    "loadingNotes": "নোট লোড হচ্ছে…",
    "noNotesYet": "এখনও কোনো নোট নেই। একটি তৈরি করতে + ট্যাপ করুন।",
    "noResults": "\"{{query}}\"-এর জন্য কোনো ফলাফল নেই",
    "noNotesTagged": "{{tag}} ট্যাগযুক্ত কোনো নোট নেই",
    "tagFilterAll": "সব",
    "filterByTag_aria": "ট্যাগ অনুযায়ী ফিল্টার করুন",
    "templates": "টেমপ্লেট",
    "editorTheme_aria": "এডিটর থিম",
    "themeActive_aria": "{{theme}} থিম (সক্রিয়)",
    "theme_aria": "{{theme}} থিম",
    "themeName": {
      "dark": "গাঢ়",
      "sepia": "সেপিয়া",
      "light": "হালকা",
      "forest": "বন"
    },
    "voice": "কণ্ঠ",
    "voice_title": "কণ্ঠ নোট",
    "voiceUnavailable_title": "এই ব্রাউজারে কণ্ঠ অনুপলব্ধ",
    "openVoiceRecorder_aria": "কণ্ঠ নোট রেকর্ডার খুলুন",
    "summarizing_title": "সারসংক্ষেপ করা হচ্ছে…",
    "summarize_title": "সারসংক্ষেপ করুন",
    "summarizeNote_aria": "নোট সারসংক্ষেপ করুন",
    "aiCommands_title": "AI কমান্ড  Cmd+K",
    "openAiPalette_aria": "AI কমান্ড প্যালেট খুলুন",
    "enterFocusMode_title": "ফোকাস মোড  Cmd+Shift+F",
    "exitFocusMode_title": "ফোকাস মোড থেকে বের হন  Cmd+Shift+F",
    "enterFocusMode_aria": "ফোকাস মোডে প্রবেশ করুন",
    "exitFocusMode_aria": "ফোকাস মোড থেকে বের হন",
    "export_title": "নোট রপ্তানি করুন",
    "delete_title": "নোট মুছুন",
    "delete_aria": "নোট মুছুন",
    "moreActions_title": "আরও ক্রিয়া",
    "wordCount_one": "{{formatted}} শব্দ · ~{{minutes}} মিনিট পড়া",
    "wordCount_other": "{{formatted}} শব্দ · ~{{minutes}} মিনিট পড়া",
    "referencedBy_one": "{{count}} দ্বারা উল্লেখিত",
    "referencedBy_other": "{{count}} দ্বারা উল্লেখিত",
    "noMatchingNotes": "কোনো মিলে যাওয়া নোট নেই",
    "mobileTabs_aria": "নোট দৃশ্য",
    "mobileTabNotes": "নোট",
    "mobileTabEditor": "এডিটর",
    "saveFailed": "নোট সংরক্ষণ করা যায়নি: {{message}}",
    "deleteFailed": "নোট মুছা যায়নি",
    "loadFailed": "নোট লোড করা যায়নি",
    "analyzeFailed": "নোট বিশ্লেষণ করা যায়নি",
    "aiCommandFailed": "AI কমান্ড ব্যর্থ হয়েছে",
    "unknownError": "অজানা ত্রুটি"
  },
  "paywall": {
    "title": "নোট Rhemn Pro-এর অংশ",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "সিঙ্কড নোট, ব্রাউজার-ভিত্তিক ডিকটেশন এবং কাঠামোবদ্ধ AI সারসংক্ষেপ উন্মোচন করুন।"
  },
  "format": {
    "bold": "বোল্ড",
    "italic": "ইটালিক",
    "strikethrough": "কাটাকাটি",
    "inlineCode": "ইনলাইন কোড",
    "heading1": "শিরোনাম ১",
    "heading2": "শিরোনাম ২",
    "heading3": "শিরোনাম ৩",
    "bulletList": "বুলেট তালিকা",
    "numberedList": "সংখ্যাযুক্ত তালিকা",
    "blockquote": "উদ্ধৃতি",
    "codeBlock": "কোড ব্লক",
    "toggleBold_aria": "বোল্ড টগল করুন",
    "toggleItalic_aria": "ইটালিক টগল করুন",
    "toggleStrikethrough_aria": "কাটাকাটি টগল করুন",
    "toggleInlineCode_aria": "ইনলাইন কোড টগল করুন",
    "toggleBulletList_aria": "বুলেট তালিকা টগল করুন",
    "toggleNumberedList_aria": "সংখ্যাযুক্ত তালিকা টগল করুন",
    "toggleBlockquote_aria": "উদ্ধৃতি টগল করুন",
    "formatOptions_aria": "ফরম্যাট বিকল্প"
  },
  "analysis": {
    "heading": "সারসংক্ষেপ",
    "onDevice": "⚡ ডিভাইসে",
    "onDevice_aria": "ডিভাইসে প্রক্রিয়াকৃত",
    "applyToNote_title": "নোটে প্রয়োগ করুন",
    "applyToNote_aria": "নোটে সারসংক্ষেপ প্রয়োগ করুন",
    "summaryLabel": "সারসংক্ষেপ",
    "keyPointsLabel": "মূল বিষয়",
    "noKeyPoints": "এই নোটের জন্য কোনো মূল বিষয় ফেরত আসেনি।"
  },
  "export": {
    "markdown": "Markdown হিসেবে রপ্তানি করুন",
    "plainText": "সাধারণ টেক্সট হিসেবে রপ্তানি করুন",
    "pdf": "PDF হিসেবে রপ্তানি করুন",
    "allZip": "সব ZIP হিসেবে রপ্তানি করুন",
    "label": "রপ্তানি"
  },
  "cmdk": {
    "dialog_aria": "AI কমান্ড প্যালেট",
    "input_placeholder": "AI-কে জিজ্ঞাসা করুন বা একটি কমান্ড চালান…",
    "esc": "Esc",
    "back_aria": "পিছনে",
    "translateTo": "অনুবাদ করুন",
    "language_placeholder": "ভাষা…",
    "aiActions": "AI ক্রিয়া",
    "noCommandsMatch": "\"{{query}}\"-এর সাথে কোনো কমান্ড মেলে না",
    "continue": {
      "label": "লেখা চালিয়ে যান",
      "description": "যেখানে থেমেছিলেন সেখান থেকে চালিয়ে যান"
    },
    "summarize": {
      "label": "নির্বাচন সারসংক্ষেপ করুন",
      "description": "মূল বিষয়ে সংক্ষিপ্ত করুন"
    },
    "formal": {
      "label": "এটি আনুষ্ঠানিক করুন",
      "description": "সুরকে পেশাদার মানে উন্নীত করুন"
    },
    "simplify": {
      "label": "সরল করুন",
      "description": "ছোট, স্পষ্ট ভাষা"
    },
    "translate": {
      "label": "অনুবাদ করুন…",
      "description": "অন্য একটি ভাষায় অনুবাদ করুন"
    },
    "expand": {
      "label": "এই বুলেটটি বিস্তৃত করুন",
      "description": "নির্বাচিত বুলেটটিকে গদ্যে রূপান্তরিত করুন"
    },
    "languages": {
      "Spanish": "স্প্যানিশ",
      "Arabic": "আরবি",
      "French": "ফরাসি",
      "German": "জার্মান",
      "Japanese": "জাপানি",
      "Portuguese": "পর্তুগিজ"
    }
  },
  "templates": {
    "dialog_aria": "টেমপ্লেট নির্বাচন করুন",
    "header": "একটি টেমপ্লেট নির্বাচন করুন",
    "builtInLabel": "অন্তর্নির্মিত",
    "myTemplatesLabel": "আমার টেমপ্লেট",
    "saveCurrent": "বর্তমান নোটটি টেমপ্লেট হিসেবে সংরক্ষণ করুন",
    "myTemplatesEmpty": "আপনার সংরক্ষিত টেমপ্লেট এখানে প্রদর্শিত হবে",
    "useTemplate": "টেমপ্লেট ব্যবহার করুন",
    "meeting": {
      "name": "মিটিং নোট",
      "description": "সিদ্ধান্ত ও করণীয় কাজ ধরে রাখুন",
      "structure": "উপস্থিতি / আলোচ্যসূচি / নোট / করণীয়"
    },
    "journal": {
      "name": "দৈনিক জার্নাল",
      "description": "আপনার দিন নিয়ে ভাবুন",
      "structure": "কৃতজ্ঞতা / আজকের সাফল্য / নোট"
    },
    "book": {
      "name": "বইয়ের সারসংক্ষেপ",
      "description": "একটি বই থেকে মূল ধারণা ধরে রাখুন",
      "structure": "মূল ধারণা / মূল উদ্ধৃতি / শিক্ষণীয় বিষয়"
    },
    "project": {
      "name": "প্রকল্প সংক্ষিপ্তসার",
      "description": "পরিধি, লক্ষ্য ও অংশীদারদের রূপরেখা দিন",
      "structure": "লক্ষ্য / পরিধি / ঝুঁকি / সময়সীমা"
    },
    "brainstorm": {
      "name": "ব্রেনস্টর্ম",
      "description": "মুক্ত-রূপে ধারণা ধরে রাখুন",
      "structure": "বিষয় / ধারণা / পরবর্তী ধাপ"
    },
    "weekly": {
      "name": "সাপ্তাহিক পর্যালোচনা",
      "description": "আপনার সপ্তাহ পর্যালোচনা ও পরিকল্পনা করুন",
      "structure": "সাফল্য / সংগ্রাম / ফোকাসের ক্ষেত্র"
    }
  },
  "voice": {
    "dialog_aria": "কণ্ঠ নোট রেকর্ডার",
    "cancel_aria": "বাতিল",
    "statusRecording": "রেকর্ডিং",
    "statusTranscribing": "প্রতিলিপি করা হচ্ছে…",
    "statusReview": "পর্যালোচনা",
    "skip": "এড়িয়ে যান",
    "mark": "চিহ্নিত করুন",
    "mark_title": "একটি টাইমস্ট্যাম্প চিহ্ন যোগ করুন",
    "captureMeeting": "মিটিং ক্যাপচার করুন",
    "captureMeeting_title": "একটি মিটিং ট্যাব থেকেও অডিও ক্যাপচার করুন",
    "meeting": "মিটিং",
    "meeting_title": "মিটিং ট্যাব ক্যাপচার করা হচ্ছে",
    "markers_aria": "টাইমস্ট্যাম্প চিহ্ন",
    "listening": "শুনছি…",
    "micDenied": "মাইক্রোফোন অ্যাক্সেস বন্ধ আছে। সেটিংস থেকে অনুমতি দিয়ে আবার চেষ্টা করুন।",
    "captureFailed": "রেকর্ডিং শুরু করা যায়নি। কিছুক্ষণ পরে আবার চেষ্টা করুন।",
    "tabPicker_aria": "ক্যাপচার করতে একটি মিটিং ট্যাব নির্বাচন করুন",
    "captureFrom": "অডিও ক্যাপচার করুন…",
    "noAudibleTab": "কোনো ট্যাব অডিও বাজাচ্ছে না। আপনার মিটিং খুলুন এবং নিশ্চিত করুন যে কেউ কথা বলছে, তারপর আবার চেষ্টা করুন।",
    "tabPickerCancel": "বাতিল",
    "tabTranscript": "প্রতিলিপি",
    "structuring": "কাঠামো তৈরি হচ্ছে…",
    "structuredNote": "কাঠামোবদ্ধ নোট",
    "structureFailed": "গঠিত নোট তৈরি করা যায়নি।",
    "retryStructure": "আবার চেষ্টা করুন",
    "browserTranscript": "ব্রাউজার প্রতিলিপি",
    "nothingCaptured": "কিছুই ক্যাপচার করা হয়নি।",
    "buildingStructured": "কাঠামোবদ্ধ নোট তৈরি হচ্ছে…",
    "cancel": "বাতিল",
    "stop": "থামান",
    "recordAgain": "আবার রেকর্ড করুন",
    "saveToNote": "নোটে সংরক্ষণ করুন",
    "statusMeeting": "মিটিং",
    "captureStrip_aria": "{{tab}} থেকে অডিও ধারণ হচ্ছে",
    "stopCapture": "ক্যাপচার বন্ধ করুন",
    "stopCapture_title": "ট্যাব ক্যাপচার বন্ধ করুন — মাইক্রোফোন রেকর্ড করতে থাকবে",
    "stopsIn": "{{time}} পরে থেমে যাবে",
    "autoStopped": "৬০ মিনিটের সীমায় রেকর্ডিং থেমে গেছে।",
    "autoStoppedQuota": "রেকর্ডিং থেমে গেছে — এই মাসের ট্রান্সক্রিপশন মিনিট শেষ।",
    "captureLost": "মিটিং ট্যাব বন্ধ হয়ে গেছে। আপনার মাইক্রোফোন এখনও রেকর্ড করছে।",
    "tabSummary": "সারসংক্ষেপ",
    "noSpeakers": "বক্তা শনাক্ত হয়নি",
    "speakerN": "বক্তা {{number}}",
    "renameSpeaker_aria": "{{name}}-এর নাম বদলান — তাঁর সব লাইনে প্রযোজ্য",
    "renameSpeaker_input_aria": "বক্তার নাম",
    "turnTime_title": "{{time}}-এ বলা",
    "actionItemsTitle": "করণীয় বিষয়",
    "actionsCount": "{{total}}টির মধ্যে {{checked}}টি",
    "addToTasks_one": "{{count}}টি টাস্কে যোগ করুন",
    "addToTasks_other": "{{count}}টি টাস্কে যোগ করুন",
    "addToTasksZero": "টাস্কে যোগ করুন",
    "adding": "যোগ করা হচ্ছে…",
    "tasksAdded_one": "{{count}}টি টাস্ক যোগ হয়েছে",
    "tasksAdded_other": "{{count}}টি টাস্ক যোগ হয়েছে",
    "viewTasks": "দেখুন",
    "addFailed": "যোগ করা যায়নি — আবার চেষ্টা করুন।",
    "minutesLeft_one": "{{count}} মিনিট বাকি",
    "minutesLeft_other": "{{count}} মিনিট বাকি",
    "minutesLeftShort_one": "{{count}} মিনিট বাকি",
    "minutesLeftShort_other": "{{count}} মিনিট বাকি",
    "minutesLeft_title": "এই মাসে {{count}} মিনিট ট্রান্সক্রিপশন বাকি",
    "quotaExhausted": "এই মাসের মিটিং মিনিট শেষ। {{date}}-এ নবায়ন হবে।",
    "quotaUnknown": "অবশিষ্ট মিনিট অজানা — রেকর্ডিং মাসিক সীমায় পৌঁছাতে পারে",
    "meetingProRequired": "মিটিং ট্রান্সক্রিপশন Pro-এর অংশ। আপনার লাইভ ট্রান্সক্রিপ্ট নিচে রাখা আছে।",
    "gateTitle": "মিটিং রেকর্ডিং",
    "gateBody": "মাইক্রোফোনের সাথে একটি মিটিং ট্যাব রেকর্ড করুন — বক্তা শনাক্তকরণ ও করণীয় নিষ্কাশনসহ। Pro-এর সাথে অন্তর্ভুক্ত।",
    "gateLater": "এখন নয়",
    "gateCta": "Pro দেখুন",
    "roomOption": "কোনো ট্যাব নয় — ঘরের আওয়াজ রেকর্ড করুন",
    "roomHint": "স্পিকারে চলা কল, আলাদা অ্যাপ, বা ঘরে থাকা মানুষ — যা কিছু আপনি সশব্দে শুনতে পান।",
    "roomHint_title": "অন্য পক্ষ যদি আপনার হেডফোনে থাকে, মাইক্রোফোন তাদের শুনতে পাবে না — স্পিকার ব্যবহার করুন।",
    "recordRoom": "ঘরের আওয়াজ রেকর্ড করুন",
    "recordRoom_title": "মাইক্রোফোন যাদের শুনতে পায় সবাইকে রেকর্ড করুন — বক্তা শনাক্তকরণসহ",
    "roomStart": "শুরু করুন",
    "statusRoom": "ঘর",
    "roomStrip": "ঘরের আওয়াজ রেকর্ড হচ্ছে",
    "roomStrip_aria": "ঘরের আওয়াজ রেকর্ড হচ্ছে — মাইক্রোফোন যাদের শুনতে পায় সবাই",
    "roomOff": "বন্ধ করুন",
    "roomOff_title": "রুম মোড বন্ধ করুন — এটি একটি সাধারণ ভয়েস নোট হয়ে যাবে",
    "roomRenameHint": "নাম বদলাতে একটি নামে ট্যাপ করুন — এদের একজন আপনি।",
    "gateBodyRoom": "আপনার চারপাশে যা বলা হয় তা রেকর্ড করুন — বক্তা শনাক্তকরণ ও করণীয় নিষ্কাশনসহ। Pro-এর সাথে অন্তর্ভুক্ত।",
    "roomHintDevice": "এই ডিভাইসের কল রেকর্ড করা যায় না — iOS সেগুলো গোপন রাখে। স্পিকারে থাকা অন্য একটি ফোন, বা ঘরের কথোপকথন, ঠিকই কাজ করে।",
    "autoStoppedSize": "আপলোড আকারের সীমায় রেকর্ডিং থেমে গেছে।",
    "tooLarge": "রেকর্ডিংটি আপলোডের জন্য খুব বড় ছিল, তাই ট্রান্সক্রাইব করা যায়নি।",
    "destTo": "তালিকা",
    "dest_aria": "তালিকায় যোগ করুন: {{name}}",
    "destMenu_aria": "একটি তালিকা বেছে নিন",
    "destNewPending_aria": "নতুন তালিকা: {{name}}"
  },
  "meetingNotice": {
    "title": "মিটিং, আপনার নোটে",
    "body": "Rhemn এখন আপনার বেছে নেওয়া মিটিং ট্যাব রেকর্ড করতে পারে — শুধু ভয়েস নোট রেকর্ড করার সময়, এবং শুধু আপনার বাছাই করা ট্যাবটিই।",
    "factPrivacy": "ট্রান্সক্রিপ্ট তৈরির জন্য অডিও প্রক্রিয়া করে ফেলে দেওয়া হয়। রেকর্ডিং কখনও সংরক্ষণ হয় না।",
    "factControl": "আপনি রেকর্ড চেপে ট্যাব না বাছা পর্যন্ত কিছুই ধারণ হয় না।",
    "cta": "বুঝেছি",
    "privacyLink": "আমাদের গোপনীয়তা নীতি পড়ুন",
    "dialog_aria": "নতুন মিটিং রেকর্ডিং অনুমতি সম্পর্কে"
  }
}
